import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import RadioBlock from '../../../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../../../components/Form/Field'

import { getStatusTagColor } from '../../../../../../../../../features/helpers/componentsHelpers'

import {
  customConversionsSelector,
  getCustomConversionsIsLoadingSelector
} from '../../../../../../../../../modules/selectors/choices'

import { selectedFacebookAdAccountSelector } from '../../../../../../../../../modules/selectors/adAccounts'
import { CONVERSION_EVENT_TYPE_RADIO_BUTTON, CUSTOM_CONVERSION_EVENT, CUSTOM_CONVERSION_ID } from '../../../../fields'
import { TARGET_COST_CAP } from '../../../../../../../../Multiplatform/LineItemForms/fields'

const CustomConversionsRadioBlock = ({ formik, showTargetCostCapField }) => {
  const { t } = useTranslation()
  const { values, setFieldValue } = formik

  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)

  const customConversions = useSelector(customConversionsSelector)
  const getCustomConversionsIsLoading = useSelector(getCustomConversionsIsLoadingSelector)

  const formattedCustomConversions = useMemo(() => {
    return customConversions.map(customConversion => ({
      ...customConversion,
      value: customConversion.id,
      label: customConversion.name,
      chip: customConversion.status,
      chipColor: getStatusTagColor(customConversion.status.toLowerCase())
    }))
  }, [customConversions])

  return (
    <RadioBlock
      setFieldValue={setFieldValue}
      name={CONVERSION_EVENT_TYPE_RADIO_BUTTON}
      id={CUSTOM_CONVERSION_EVENT}
      value={CUSTOM_CONVERSION_EVENT}
      label={t('Custom conversion event')}
      selectedValue={values[CONVERSION_EVENT_TYPE_RADIO_BUTTON]}
    >
      <h3>{t('Select the custom conversion event to optimise towards.')}</h3>
      <Field
        placeholder={t('Custom conversion event')}
        formik={formik}
        name={CUSTOM_CONVERSION_ID}
        options={formattedCustomConversions}
        isLoading={getCustomConversionsIsLoading}
      />
      {showTargetCostCapField && (
        <Field
          type="number"
          formik={formik}
          name={TARGET_COST_CAP}
          placeholder={t('Average Cost Goal')}
          symbol={currencySymbol}
          autoComplete="off"
        />
      )}
    </RadioBlock>
  )
}

CustomConversionsRadioBlock.propTypes = {
  formik: PropTypes.object.isRequired,
  showTargetCostCapField: PropTypes.bool.isRequired
}

export default CustomConversionsRadioBlock
